import { useParams } from 'react-router-dom';

import { ChronologiesTable } from './components/chronologies-table';
import { SubsetChip } from '../../../../../../components/subset-chip';
import { useGetCase } from '@/api/queries/useGetCase';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';
import { PageTitle } from '@/new/components/page-title';
import { useSubsetBreadcrumbs } from '@/new/hooks/use-subset-breadcrumbs';

export function Chronologies() {
  const { matterId, subsetId } = useParams();
  if (!matterId || !subsetId) return null;

  const { data: matterData } = useGetMatterV2(matterId);
  const { data: subsetData } = useGetCase(subsetId);

  const breadcrumbItems = useSubsetBreadcrumbs({
    matterId,
    subsetId,
    matter: matterData,
    subset: subsetData,
    currentPage: { label: 'Chronologies', path: 'chronologies' },
  });

  return (
    <>
      <Breadcrumb items={breadcrumbItems} />

      <PageContainer>
        <PageHeader>
          <div className="flex items-center gap-4">
            <PageTitle text="Chronologies" />
            <SubsetChip subsetId={subsetId} className="mt-0.5" />
          </div>
        </PageHeader>
      </PageContainer>

      <ChronologiesTable />
    </>
  );
}
